<div class="modal-container d-flex flex-column h-auto">
  <div class="modal-header border-0">
    <h1 class="text-primary-color mb-0">{{ CompnayID != undefined ? editName : headingsNames}}</h1>
  </div>

  <div class="modal-body flex-grow-1 overflow-y-auto overflow-x-hidden">
        <!-- requirement information start -->
        <div class="row mx-0">
          <div class="col-12 col-lg-3 px-0">
            <div class="row mx-0 form-fields__container">
              <div class="col-auto col-md-6 col col-lg-12 ps-0 mb-3">
                <span class="d-flex popup-secondary-text text-gray">Requirement Number:</span>
                <span class="secondary-text text-primary-color">{{requirementInfo?.requirementNo ?
                  requirementInfo?.requirementNo :'-'}}</span>
              </div>
              <div class="d-block d-lg-none col pe-0 mb-3">
                <div class="row mx-0 flex-nowrap">
                  <div class="px-0">
                    <app-checkbox class="d-flex justify-content-end pe-3" [lableClass]="'hand m-0 text-wrap'"
                      [status]="requirementInfo?.isInHouseRequirement" [readonly]="requirementInfo.id"
                      [isSelectedAdmin]="requirementInfo.id"
                      (check)="requirementInfo.isInHouseRequirement = $event;checkedInHouse()"
                      [dyanamicId]="'inHouseRequirement'" [lableName]="'In House Requirement'">
                    </app-checkbox>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-12 mb-3 requirement px-0 pe-md-2 form-field__wrapper">
                <label for="" class="meta-field text-semi-primary hand mb-0 font-14" (click)="openAddEditCompanyModal()">+ Add Company </label>
                <app-input-search id="typeahead-format" [isInputDisabled]="requirementInfo.isInHouseRequirement"
                  [inputType]="'text'" [inputLabel]="'Company'" [inputReqValidation]="true"
                  [ngbTypeahead]="reqCompanySearch" [inputValue]="companyName"
                  (inputValueEmit)="selectValueChange($event)"
                  (keydownSearchLedger)="companyInputEvent($event)"
                   [ngClass]="{'border-red':!requirementInfo.companyId &&  submit }"
                  (selectItem)="selectValueChange($event)"
                  (blur)="clearInputText()"></app-input-search>
                <!-- [ngClass]="{'border-red':!requirementInfo.companyId && submit}" -->
              </div>
              <div class="col-12 col-md-6 col-lg-12 mb-3 px-0 ps-md-2 ps-lg-0 pe-lg-2">
                <app-input [inputLabel]="'Customer RFQ No.'" [inputType]="'text'"
                  [inputValue]="requirementInfo.customerRFQ" [isInputDisabled]="requirementInfo.isInHouseRequirement"
                  (inputValueEmit)="requirementInfo.customerRFQ = $event">
                </app-input>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-5 px-0">
            <div class="row mx-0 form-fields__container">
              <div class="col-12 mb-3 px-0 ps-md-4">
                <span class="d-flex popup-secondary-text text-gray">Requirement Date:</span>
                <span class="secondary-text text-primary-color">
                  {{ requirementInfo?.requirementDate ?(requirementInfo?.requirementDate | date:'MM/dd/yyyy') :
                  (todayDate | date:'MM/dd/yyyy') }}
                </span>
              </div>
              <div class="col-12 col-md-6 mb-3 form-field__wrapper requirement px-0 pe-md-2 ps-lg-2">
                <label for="" class="meta-field text-semi-primary font-14 pe-2" [ngClass]="{'cursor-not-allowed opacity-50': (!requirementInfo.companyId || requirementInfo.isInHouseRequirement), 'hand': (requirementInfo.companyId && !requirementInfo.isInHouseRequirement) }" (click)="requirementInfo.companyId && !requirementInfo.isInHouseRequirement && openAddContactModal()">+Add
                  Contact
                </label>
                <app-dropdown [selectLabel]="'Contact'" [data]="contactList" [selectValue]="requirementInfo?.contactId"
                  [required]="true" [ngClass]="{'border-red':!requirementInfo.contactId && submit}" (selectValueEmit)=" requirementInfo.contactId = $event"
                  [disabled]="disabledContact || requirementInfo.isInHouseRequirement ? true : false">
                </app-dropdown>
              </div>
              <div class="col-12 col-md-6 mb-3 px-0 ps-md-2 pe-lg-2">
                <app-dropdown [selectLabel]="'Req Source'" [data]="getAllDropdown?.requirementSourceList"
                  [selectValue]="requirementInfo.requirementSourceId" [disabled]="requirementInfo.isInHouseRequirement"
                  (selectValueEmit)="requirementInfo.requirementSourceId = $event">
                </app-dropdown>
              </div>
              <div class="col-12 col-md-6 mb-3 px-0 pe-md-2 ps-lg-2">
                <app-dropdown [selectLabel]="'Priority'" [data]="getAllDropdown?.priorityList"
                  [selectValue]="requirementInfo.priorityId" (selectValueEmit)="requirementInfo.priorityId = $event"
                  [disabled]="requirementInfo.isInHouseRequirement">
                </app-dropdown>
              </div>
              <div class="col-12 col-md-6 mb-3 px-0 ps-md-2 pe-lg-2">
                <app-dropdown [selectLabel]="'Salesperson'" [data]="getAllDropdown?.salesPersonList"
                  [selectValue]="requirementInfo.salesPersonId"
                  (selectValueEmit)="requirementInfo.salesPersonId = $event"
                  [disabled]="requirementInfo.isInHouseRequirement">
                </app-dropdown>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-4 px-0">
            <div class="col d-none d-lg-block ms-3 ms-lg-0 px-0">
              <div class="row mx-0 flex-nowrap">
                <div class="px-0">
                  <app-checkbox class="d-flex justify-content-end pe-3" [lableClass]="'hand m-0 text-wrap'"
                    [status]="requirementInfo?.isInHouseRequirement" [readonly]="requirementInfo.id"
                    [isSelectedAdmin]="requirementInfo.id"
                    (check)="requirementInfo.isInHouseRequirement = $event;checkedInHouse()"
                    [dyanamicId]="'inHouseRequirement'" [lableName]="'In House Requirement'">
                  </app-checkbox>
                </div>
              </div>
            </div>
            <div class="col-12 noteWidth p-0 pt-lg-3 ps-lg-2">
              <div class="mt-lg-4">
                <app-textarea 
                  [label]="'Customer Note'"
                  [isRequired]="false"
                  [textareaHeight]="'115px'"
                  [name]="'customerNote'"
                  [id]="'customerNote'"
                  [isDisable]="requirementInfo.isInHouseRequirement"
                  [inputValue]="requirementInfo.customerNotes"
                  (inputValueEmit)="requirementInfo.customerNotes = $event"
                ></app-textarea>
              </div>

              <!-- <div class="d-flex flex-column position-relative addNote mt-lg-4"
                [ngClass]="{'disabled-text': requirementInfo.isInHouseRequirement}">
                <label class="form-label position-absolute addLabel font-16" for="">
                  Customer Note
                </label>
                <textarea [readonly]="requirementInfo.isInHouseRequirement" name="note" rows="3"
                  class="form-control mx-3 mt-4 pt-1 font-13 Textarea" [(ngModel)]="requirementInfo.customerNotes">
          </textarea>
              </div> -->
            </div>
          </div>
        </div>
        <!-- requirement information end-->
        <div class="row mx-0 requirement-details__container mt-3 mt-lg-0">
          <div class="mt-3 mt-lg-0 tab-navigation-wrapper px-0">
            <!-- Small screen: navigation with arrows -->
            <div *ngIf="!isLargeScreen" class="list-navigation gap-3 d-flex">
              <img class="hand" (click)="moveLeft()" src="./../../../../../../assets/SVGIcons/listLeftArrow.svg" alt="">
              <div #widgetsContent class="list-container">
                <ul class="nav-tabs d-flex align-items-center text-nowrap mb-0">
                  <li class="pb-2"
                    [ngStyle]="{'border-bottom': active === 1 ? '1px solid var(--sitewide_primary_accent_color)' : '1px solid transparent'}">
                    <div class="hand  tab-view" [ngClass]="active === 1 ? 'text-primary-color' : 'text-light-gray'"
                      (click)="activeTab(1)">
                      Requirement Details
                    </div>
                  </li>
                  <li class="pb-2"
                    [ngStyle]="{'border-bottom': active === 2 ? '1px solid var(--sitewide_primary_accent_color)' : '1px solid transparent'}">
                    <div class="hand  tab-view" [ngClass]="active === 2 ? 'text-primary-color' : 'text-light-gray'"
                      (click)="activeTab(2)">
                      Part Details
                    </div>
                  </li>
                  <li class="pb-2"
                    [ngStyle]="{'border-bottom': active === 3 ? '1px solid var(--sitewide_primary_accent_color)' : '1px solid transparent'}">
                    <div class="hand  tab-view" [ngClass]="active === 3 ? 'text-primary-color' : 'text-light-gray'"
                      (click)="activeTab(3)">
                      Fulfillment
                    </div>
                  </li>
                  <li class="pb-2"
                    [ngStyle]="{'border-bottom': active === 4 ? '1px solid var(--sitewide_primary_accent_color)' : '1px solid transparent'}">
                    <div class="hand  tab-view" [ngClass]="active === 4 ? 'text-primary-color' : 'text-light-gray'"
                      (click)="activeTab(4)">
                      Additional Quantity
                    </div>
                  </li>
                </ul>
              </div>
              <img class="hand" (click)="moveRight()" src="./../../../../../../assets/SVGIcons/listRightArrow.svg"
                alt="">
            </div>
            <!-- Main nav with content - hidden on small screens, visible on large -->
            <ul ngbNav #nav="ngbNav" [(activeId)]="active" [ngClass]="{'d-none': !isLargeScreen}"
              class="nav-tabs d-flex align-items-center">
              <!-- requirement details start -->
              <li [ngbNavItem]="1" class="pb-2 p-e-2 me-3"
                [ngStyle]="{'border-bottom': active === 1 ? '1px solid var(--sitewide_primary_accent_color)' : '1px solid transparent'}">
                <div class="hand  tab-view" [ngClass]="active === 1 ? 'text-primary-color' :  'text-light-gray'"
                  (click)="activeTab(1)" ngbNavLink>
                  Requirement Details
                </div>
                <ng-template ngbNavContent>
                  <div class="row mx-0 pt-4 form-fields__container">
                    <div class="form-field__wrapper col-12 col-md-6 col-lg-2 col-xl-3 mb-3 px-0 pe-md-2 pe-lg-2">
                      <label for="" class="meta-field text-semi-primary hand font-14" (click)="openAddPartPopup('Add Part')">+Add Part</label>
                      <app-search-bar-dropdown [searchDropdown]="true" class="search-dropdown"
                        [id]="'typeahead-format1'" [name]="'MPN'" [selectLabel]="'MPN'" [inputReqValidation]="true"  [ngClass]="{'border-red':!requirementDetails?.mpnId&&  submit }"
                        [dataList]="getAllDropdown?.mpnList | dependentFilter : requirementDetails?.mpnId : requirementDetails?.mfrId : 'mpn': getAllDropdown?.mpnList"
                        (inputValueEmit)="selectMpnValueChange($event, 'mpn')"
                        [selectedId]="requirementDetails.mpnId">
                      </app-search-bar-dropdown>
                    </div>
                    <div class="form-field__wrapper col-12 col-md-6 col-lg-2 col-xl-3  mb-3 px-0 ps-md-2 pe-lg-2">
                      <label for="" class="meta-field text-semi-primary hand font-14"  (click)="openAddEditMFRModal()">+Add MFR</label>
                      <app-search-bar-dropdown [searchDropdown]="true" class="search-dropdown" 
                        [id]="'typeahead-format1'" [name]="'MFR'" [selectLabel]="'MFR'" [inputReqValidation]="true" [ngClass]="{'border-red':!requirementDetails.mfrId &&  submit }"
                        [dataList]="getAllDropdown?.masterManufacturerWithChildrenList | dependentFilter : requirementDetails?.mpnId : requirementDetails?.mfrId : 'mfr' : getAllDropdown?.mpnList"
                        (inputValueEmit)="selectMpnValueChange($event, 'mfr')"[optionDisable]="data?.isFromSourcing || offerForRFQ || data?.viewOffer"
                        [selectedId]="requirementDetails.mfrId">
                      </app-search-bar-dropdown>
                    </div>
                    <div class="form-field__wrapper col-12 col-md-6 col-lg-2 mb-3 px-0 pe-md-2 ps-lg-2">
                      <label for="" class="meta-field text-danger font-14" *ngIf="additionalQuantities.length && hasAdditionalQuantity()">Additional Qty(s)</label>
                      <app-input onlyNumbers [inputLabel]="'Qty'" [inputType]="'text'" [inputReqValidation]="true" [ngClass]="{'border-red':!requirementDetails.qty &&  submit }"
                        [inputValue]="requirementDetails.qty" (inputValueEmit)="requirementDetails.qty = $event">
                      </app-input>
                    </div>
                    <div class="form-field__wrapper col-12 col-md-6 col-lg-3 col-xl-2 mb-3 px-0 ps-md-2 pe-lg-2">
                      <label for="" class="meta-field text-danger font-14">{{companySettingDetails?.dateCodeRestrictionName ? companySettingDetails?.dateCodeRestrictionName + ' restriction' : ''}} </label>
                      <app-dropdown [selectLabel]="'Date Code Year'" [data]="getAllDropdown?.dcCodeYearList" [required]="true"
                        [selectValue]="requirementDetails.dateCodeYearId"
                        [ngClass]="{'border-red':!requirementDetails.dateCodeYearId &&  submit }"
                        (selectValueEmit)="requirementDetails.dateCodeYearId = $event">
                      </app-dropdown>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3 col-xl-2 mb-3 px-0 pe-md-2 ps-lg-2 pe-lg-0">
                      <app-dropdown [selectLabel]="'Date Code Week'" [data]="getAllDropdown?.dcCodeWeekList" [required]="true"
                        [selectValue]="requirementDetails.dateCodeWeekId"
                        [ngClass]="{'border-red':!requirementDetails.dateCodeWeekId &&  submit }"
                        (selectValueEmit)="requirementDetails.dateCodeWeekId = $event">
                      </app-dropdown>
                    </div>
                  </div>
                  <div class="row mx-0">
                    <div class="col-12 col-md-6 col-lg-3 mb-3 px-0 pe-md-2">
                      <app-input [inputLabel]="'Customer PN'" [inputType]="'text'"
                        [inputValue]="requirementDetails.customerPN"
                        (inputValueEmit)="requirementDetails.customerPN = $event">
                      </app-input>
                    </div>
                    <div class="col-12 col-md-6 col-lg-2 col-xl-3 mb-3 px-0 ps-md-2 pe-lg-2">
                      <app-input [inputLabel]="'NSN'" [inputType]="'text'" [inputValue]="requirementDetails.nsn"
                        (inputValueEmit)="requirementDetails.nsn = $event"
                        [isInputDisabled]="disabledMPNfields == true ? true : false">
                      </app-input>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3 col-xl-2 mb-3 px-0 pe-md-2 ps-lg-2">
                      <app-dropdown [selectLabel]="'RoHS'" [required]="true" [data]="getAllDropdown?.roHSList"
                        [selectValue]="requirementDetails.rohsId"
                          [ngClass]="{'border-red':!requirementDetails.rohsId &&  submit }"
                        (selectValueEmit)="requirementDetails.rohsId = $event">
                      </app-dropdown>
                    </div>
                    <div class="col-12 col-md-6 col-lg-2 mb-3 px-0 ps-md-2 pe-lg-2">
                      <app-dropdown [selectLabel]="'Condition'" [required]="true"
                           [ngClass]="{'border-red':!requirementDetails.conditionId &&  submit }"
                        [data]="getAllDropdown?.inventoryConditionsList" [selectValue]="requirementDetails.conditionId"
                        (selectValueEmit)="requirementDetails.conditionId = $event">
                      </app-dropdown>
                    </div>
                    <div class="col-12 col-md-6 col-lg-2 mb-3 px-0 pe-md-0 ps-lg-2">
                      <app-dropdown [selectLabel]="'Item Pkg'" [data]="getAllDropdown?.itemPackagingList "
                        [selectValue]="requirementDetails.itemPkgId"
                        (selectValueEmit)="requirementDetails.itemPkgId = $event">
                      </app-dropdown>
                    </div>
                  </div>
                  <div class="row mx-0 form-fields__container">
                    <div class="col-12 col-lg-3 col-xl-6 mb-3 px-0 pe-lg-2">
                      <app-input [inputLabel]="'Description'" [inputType]="'text'"
                        [inputValue]="requirementDetails.description"
                        (inputValueEmit)="requirementDetails.description = $event"
                        [isInputDisabled]="disabledMPNfields == true ? true : false">
                      </app-input>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3 col-xl-2 mb-3 px-0 pe-md-2 ps-lg-2">
                      <app-input [inputLabel]="'Revision'" [inputType]="'text'"
                        [inputValue]="requirementDetails.revision"
                        (inputValueEmit)="requirementDetails.revision = $event">
                      </app-input>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3 col-xl-2 mb-3 px-0 ps-md-2 pe-lg-2">
                      <app-dropdown [selectLabel]="'COO'" [data]="getAllDropdown?.countryList"
                        [selectValue]="requirementDetails.cooId" (selectValueEmit)="requirementDetails.cooId = $event">
                      </app-dropdown>
                    </div>
                    <div class="form-field__wrapper col-12 col-md-6 col-lg-3 col-xl-2 mb-3 px-0 pe-md-2 ps-lg-2 pe-lg-0">
                      <ng-container *ngIf="companySettingDetails?.required3rdPartyTestReport">
                        <label for="" class="meta-field text-danger font-14 pe-0 hand" [ngbTooltip]="'Company Setting'" placement="bottom" container="body">Required</label>
                      </ng-container>
                      <app-dropdown [selectLabel]="'Testing'" [data]="getAllDropdown?.testingList"
                        [selectValue]="requirementDetails.testingId"
                        (selectValueEmit)="requirementDetails.testingId = $event">
                      </app-dropdown>
                    </div>
                  </div>
                  <div class="row mx-0">
                    <div class="col-12 col-md-6 col-lg-3 col-xl-2 mb-2 px-0 pe-md-2">
                      <app-input onlyNumbers [inputLabel]="'Customer Target'" [inputType]="'text'"
                        [inputValue]="requirementDetails.customerTargetPrice"
                        (inputValueEmit)="requirementDetails.customerTargetPrice = $event"
                        [isInputDisabled]="requirementInfo.isInHouseRequirement">
                      </app-input>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3 col-xl-2 mb-2 px-0 ps-md-2 pe-lg-2">
                      <app-dropdown [selectLabel]="'Currency'" [data]="getAllDropdown?.currencyList"
                        [selectValue]="requirementDetails.currencyId"
                        (selectValueEmit)="requirementDetails.currencyId = $event"
                        [disabled]="requirementInfo.isInHouseRequirement">
                      </app-dropdown>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3 col-xl-2 mb-2 px-0 pe-md-2 ps-lg-2">
                      <app-input numberFormat [inputLabel]="'Exchange Rate'" [inputType]="'text'"
                        [inputValue]="requirementDetails.exchangeRate"
                        (inputValueEmit)="requirementDetails.exchangeRate = $event"
                        [isInputDisabled]="requirementInfo.isInHouseRequirement">
                      </app-input>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3 col-xl-2 mb-2 px-0 ps-md-2 pe-lg-0 pe-xl-2">
                      <app-input onlyNumbers [inputLabel]="'Converted Target'" [inputType]="'text'"
                        [inputValue]="requirementDetails.convertedTargetPrice"
                        (inputValueEmit)="requirementDetails.convertedTargetPrice = $event"
                        [isInputDisabled]="requirementInfo.isInHouseRequirement">
                      </app-input>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3 col-xl-2 mb-2 px-0 pe-md-2 ps-lg-0 ps-xl-2">
                      <app-input onlyNumbers [inputLabel]="'Target Buy Price'" [inputType]="'text'"
                        [inputValue]="requirementDetails.targetBuyPrice"
                        (inputValueEmit)="requirementDetails.targetBuyPrice = $event"
                        [isInputDisabled]="requirementInfo.isInHouseRequirement">
                      </app-input>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3 col-xl-2 mb-2 px-0 ps-md-2 ps-lg-2 pe-lg-2">
                      <app-date-picker 
                        [time]="false" [inputReqValidation]="true" 
                        [ngClass]="{'border-red':!requirementDetails.needDate &&  submit }"
                        [inputLabel]="'Need Date'"
                        [inputValue]="requirementDetails.needDate"
                        (inputValueEmit)="requirementDetails.needDate = $event"
                        [isDisabled]="requirementInfo.isInHouseRequirement"
                        [adjustPopupPosition]="'top-right'"
                        ></app-date-picker>
                    </div>
                  </div>

                </ng-template>
              </li>
              <!-- requirement details end -->

              <!-- requirement part details start -->
              <li [ngbNavItem]="2" class="pb-2 me-5 tab-view"
                [ngStyle]="{'border-bottom': active === 2 ? '1px solid var(--sitewide_primary_accent_color)' : '1px solid transparent'}">
                <div class="hand tab-view" [ngClass]="active === 2 ? 'text-primary-color' :  'text-light-gray'"
                  (click)="activeTab(2)" ngbNavLink>
                  Part Details
                </div>
                <ng-template ngbNavContent>
                  <div class="row mx-0 pt-3">
                    <div class="col-12 col-md-6 col-lg-3 mb-4 px-0 pe-md-2">
                      <app-dropdown [selectLabel]="'Category Group'" [data]="getAllDropdown?.categoryGroupList"
                        [selectValue]="requirementParts?.categoryGroupId"
                        (selectValueEmit)="requirementParts.categoryGroupId = $event;onChangedValue($event,enumFilterLabel?.CATEGORY_GROUP)">
                      </app-dropdown>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3 mb-4 px-0 ps-md-2 pe-lg-2">
                      <app-dropdown [selectLabel]="'Parent Category'" [data]="getAllDropdown.parentCategoryGroupList"
                        [selectValue]="requirementParts?.parentCategoryId"
                        (selectValueEmit)="requirementParts.parentCategoryId = $event;onChangedValue($event,enumFilterLabel?.PARENT_CATEGORY)"
                        [disabled]="!requirementParts?.categoryGroupId">
                      </app-dropdown>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3 mb-4 px-0 pe-md-2 ps-lg-2">
                      <app-dropdown [selectLabel]="'Category'" [data]="getAllDropdown?.inventoryCategoryList"
                        [selectValue]="requirementParts?.categoryId"
                        (selectValueEmit)="requirementParts.categoryId = $event;onChangedValue($event,enumFilterLabel?.CATEGORY)"
                        [disabled]="!requirementParts?.parentCategoryId">
                      </app-dropdown>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3 mb-4 px-0 ps-md-2">
                      <app-dropdown [selectLabel]="'Sub-Category'" [data]="getAllDropdown?.subCategoryList"
                        [selectValue]="requirementParts?.subCategoryId"
                        (selectValueEmit)="requirementParts.subCategoryId = $event"
                        [disabled]="!requirementParts?.categoryId">
                      </app-dropdown>
                    </div>
                  </div>
                  <div class="row mx-0">
                    <div class="col-12 col-md-6 col-lg-3 mb-4 px-0 pe-md-2">
                      <app-input [inputLabel]="'SPQ'" [inputType]="'text'" [inputValue]="requirementParts?.spq"
                        (inputValueEmit)="requirementParts.spq = $event"
                        [isInputDisabled]="disabledMPNfields == true ? true : false">
                      </app-input>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3 mb-4 px-0 ps-md-2 pe-lg-2">
                      <app-input [inputLabel]="'MOQ'" [inputType]="'text'" [inputValue]="requirementParts?.moq"
                        (inputValueEmit)="requirementParts.moq = $event">
                      </app-input>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3 mb-4 px-0 pe-md-2 ps-lg-2">
                      <app-input [inputLabel]="'HTS'" [inputType]="'text'" [inputValue]="requirementParts?.hts"
                        (inputValueEmit)="requirementParts.hts = $event">
                      </app-input>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3 mb-4 px-0 ps-md-2">
                      <app-input [inputLabel]="'Schedule B'" [inputType]="'text'"
                        [inputValue]="requirementParts?.scheduleB"
                        (inputValueEmit)="requirementParts.scheduleB = $event"
                        [isInputDisabled]="disabledMPNfields == true ? true : false">
                      </app-input>
                    </div>
                  </div>
                  <div class="row mx-0">
                    <div class="col-12 col-md-6 col-lg-3 mb-4 px-0 pe-md-2">
                      <app-input [inputLabel]="'ECCN'" [inputType]="'text'" [inputValue]="requirementParts?.eccn"
                        (inputValueEmit)="requirementParts.eccn = $event"
                        [isInputDisabled]="disabledMPNfields == true ? true : false">
                      </app-input>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3 mb-4 px-0 ps-md-2 pe-lg-2">
                      <app-input [inputLabel]="'Temp Range'" [inputType]="'text'"
                        [inputValue]="requirementParts?.tempRange"
                        (inputValueEmit)="requirementParts.tempRange = $event"
                        [isInputDisabled]="disabledMPNfields == true ? true : false">
                      </app-input>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3 mb-4 px-0 pe-md-2 ps-lg-2">
                      <app-dropdown [selectLabel]="'Part Status'" [data]="getAllDropdown?.partStatusList"
                        [selectValue]="requirementParts?.partStatusId"
                        (selectValueEmit)="requirementParts.partStatusId = $event">
                      </app-dropdown>
                    </div>
                  </div>
                </ng-template>
              </li>
              <!-- requirement part details end -->

              <!-- requirement Fulfillment details start -->
              <li [ngbNavItem]="3" class="pb-2 me-5"
                [ngStyle]="{'border-bottom': active === 3 ? '1px solid var(--sitewide_primary_accent_color)' : '1px solid transparent'}">
                <div class="hand tab-view" [ngClass]="active === 3 ? 'text-primary-color' :  'text-light-gray'"
                  (click)="activeTab(3)" ngbNavLink>
                  Fulfillment
                </div>
                <ng-template ngbNavContent>
                  <div class="row mx-0 pt-2">
                    <div class="col-xl-4 col-sm-6 col-12 px-0">
                      <div class="row d-flex mx-0">
                        <div class="col-lg-10 col-sm-11 col-12 ps-0 fulfillment-item">
                          <div class="text-primary-color secondary-text d-flex align-items-center">
                            {{enumFullFillmentNames.DOCUMENTATION}}
                          </div>
                        </div>
                        <div class="col-lg-10 col-sm-11 col-12 px-0 mt-3 mb-2">
                          <div class="d-flex justify-content-between">
                            <div class="form-check"
                              (click)="updateFullfillmentData(enumFullFillmentNames.DOCUMENTATION)">
                              <input class="form-check-input checkbox" type="checkbox"
                                [checked]="companySettingDetails?.manufacturerCOC" [disabled]="true" id="mfrCOC"
                                name="{{enumFullFillmentNames.DOCUMENTATION}}" />
                              <label class="form-check-label secondary-text" for="mfrCOC">
                                Manufacturer COC
                              </label>
                            </div>
                            <ng-container
                              *ngIf="requirementInfo.isInHouseRequirement && !fulfillmentDetails?.manufacturerCOC">
                              <app-svg [ngClass]="{'cursor-notAllowed pe-none': requirementInfo.isInHouseRequirement}"
                                class="d-flex align-items-center" iconType="AddCircleDisabled">
                              </app-svg>
                            </ng-container>
                            <ng-container
                              *ngIf="!requirementInfo.isInHouseRequirement && !fulfillmentDetails?.manufacturerCOC">
                              <app-svg class="d-flex align-items-center" iconType="AddCircleEnabled"
                                (click)="fulfillmentDetails.manufacturerCOC = !fulfillmentDetails.manufacturerCOC;updateFullfillmentData('Documentation')">
                              </app-svg>
                            </ng-container>
                            <ng-container *ngIf="fulfillmentDetails?.manufacturerCOC">
                              <app-svg class="d-flex align-items-center" iconType="BigCheck"
                                (click)="fulfillmentDetails.manufacturerCOC = !fulfillmentDetails.manufacturerCOC;updateFullfillmentData('Documentation')">
                              </app-svg>
                            </ng-container>
                          </div>
                        </div>
                        <div class="col-lg-10 col-sm-11 col-12 px-0 mb-2">
                          <div class="d-flex justify-content-between">
                            <div class="form-check"
                              (click)="updateFullfillmentData(enumFullFillmentNames.DOCUMENTATION)">
                              <input class="form-check-input checkbox" type="checkbox"
                                [checked]="companySettingDetails?.companyCOC" [disabled]="true" id="flexCheckDefault8"
                                name="{{enumFullFillmentNames.DOCUMENTATION}}" />
                              <label class="form-check-label secondary-text" for="flexCheckDefault8">
                                Company COC
                              </label>
                            </div>
                            <ng-container
                              *ngIf="requirementInfo.isInHouseRequirement && !fulfillmentDetails.companyCOC">
                              <app-svg [ngClass]="{'cursor-notAllowed pe-none': requirementInfo.isInHouseRequirement}"
                                class="d-flex align-items-center" iconType="AddCircleDisabled">
                              </app-svg>
                            </ng-container>
                            <ng-container
                              *ngIf="!requirementInfo.isInHouseRequirement && !fulfillmentDetails.companyCOC">
                              <app-svg class="d-flex align-items-center" iconType="AddCircleEnabled"
                                (click)="fulfillmentDetails.companyCOC = !fulfillmentDetails?.companyCOC;updateFullfillmentData('Documentation')">
                              </app-svg>
                            </ng-container>
                            <ng-container *ngIf="fulfillmentDetails.companyCOC">
                              <app-svg class="d-flex align-items-center" iconType="BigCheck"
                                (click)="fulfillmentDetails.companyCOC = !fulfillmentDetails?.companyCOC;updateFullfillmentData('Documentation')">
                              </app-svg>
                            </ng-container>
                          </div>
                        </div>
                        <div class="col-lg-10 col-sm-11 col-12 px-0 mb-2">
                          <div class="d-flex justify-content-between">
                            <div class="form-check"
                              (click)="updateFullfillmentData(enumFullFillmentNames.DOCUMENTATION)">
                              <input class="form-check-input checkbox" type="checkbox"
                                [checked]="companySettingDetails?.requiredImages" [disabled]="true"
                                name="{{enumFullFillmentNames.DOCUMENTATION}}" id="flexCheckDefault10" />
                              <label class="form-check-label secondary-text" for="flexCheckDefault10">
                                Requires Images
                              </label>
                            </div>
                            <ng-container
                              *ngIf="requirementInfo.isInHouseRequirement && !fulfillmentDetails.requiredImages">
                              <app-svg [ngClass]="{'cursor-notAllowed pe-none': requirementInfo.isInHouseRequirement}"
                                class="d-flex align-items-center" iconType="AddCircleDisabled">
                              </app-svg>
                            </ng-container>
                            <ng-container
                              *ngIf="!requirementInfo.isInHouseRequirement && !fulfillmentDetails.requiredImages">
                              <app-svg class="d-flex align-items-center" iconType="AddCircleEnabled"
                                (click)="fulfillmentDetails.requiredImages = !fulfillmentDetails.requiredImages;updateFullfillmentData('Documentation')">
                              </app-svg>
                            </ng-container>
                            <ng-container *ngIf="fulfillmentDetails.requiredImages">
                              <app-svg class="d-flex align-items-center" iconType="BigCheck"
                                (click)="fulfillmentDetails.requiredImages = !fulfillmentDetails.requiredImages;updateFullfillmentData('Documentation')">
                              </app-svg>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-4 col-sm-6 col-12 px-0">
                      <div class="row d-flex mx-0">
                        <div class="col-lg-10 col-sm-11 col-12 ps-0 fulfillment-item">
                          <div class="text-primary-color secondary-text d-flex align-items-center">
                            {{enumFullFillmentNames.QUALITY_CONTROL}}
                          </div>
                        </div>
                        <div class="col-lg-10 col-sm-11 col-12 px-0 mt-3 mb-2">
                          <div class="d-flex justify-content-between">
                            <div class="form-check"
                              (click)="updateFullfillmentData(enumFullFillmentNames.QUALITY_CONTROL)">
                              <input class="form-check-input checkbox" type="checkbox"
                                [checked]="companySettingDetails?.requiredInspectionReport" [disabled]="true"
                                id="flexCheckDefault20" name="{{enumFullFillmentNames.QUALITY_CONTROL}}" />
                              <label class="form-check-label popup-secondary-text" for="flexCheckDefault20">
                                Inspection Report Required
                              </label>
                            </div>
                            <ng-container
                              *ngIf="requirementInfo.isInHouseRequirement && !fulfillmentDetails.requiredInspectionReport">
                              <app-svg [ngClass]="{'cursor-notAllowed pe-none': requirementInfo.isInHouseRequirement}"
                                class="d-flex align-items-center" iconType="AddCircleDisabled">
                              </app-svg>
                            </ng-container>
                            <ng-container
                              *ngIf="!requirementInfo.isInHouseRequirement && !fulfillmentDetails.requiredInspectionReport">
                              <app-svg class="d-flex align-items-center" iconType="AddCircleEnabled"
                                (click)="fulfillmentDetails.requiredInspectionReport = !fulfillmentDetails.requiredInspectionReport;updateFullfillmentData('Quality Control')">
                              </app-svg>
                            </ng-container>
                            <ng-container *ngIf="fulfillmentDetails.requiredInspectionReport">
                              <app-svg class="d-flex align-items-center" iconType="BigCheck"
                                (click)="fulfillmentDetails.requiredInspectionReport = !fulfillmentDetails.requiredInspectionReport;updateFullfillmentData('Quality Control')">
                              </app-svg>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </li>
              <!-- requirement Fulfillment details end -->

              <!-- requirement Additional Quantity details start -->
              <li [ngbNavItem]="4" class="pb-2"
                [ngStyle]="{'border-bottom': active === 4 ? '1px solid var(--sitewide_primary_accent_color)' : '1px solid transparent'}">
                <div class="hand tab-view" [ngClass]="active === 4 ? 'text-primary-color' :  'text-light-gray'"
                  (click)="activeTab(4)" ngbNavLink>
                  Additional Quantity
                </div>
                <ng-template ngbNavContent>
                  <div class="row mx-0">
                    <div class="col-12 ps-0 d-flex mb-1 justify-content-end align-items-center hand">
                      <app-svg-icon class="svgIcon me-1" [src]="'../../../../assets/SVGIcons/Plus.svg'"></app-svg-icon>
                      <span class="fs-10 alternate-text-color" (click)="addAdditionalQty()">Add Additional
                        Quantity</span>
                    </div>
                  </div>
                  <div class="row mx-0">
                    <div class="col-12 col-md-5 col-lg-2 ps-0 mb-2 mb-lg-0">
                      <app-input onlyNumbers [inputLabel]="'Qty'" [inputType]="'text'" [isInputDisabled]="true"
                        [inputReqValidation]="true" [inputValue]="requirementDetails?.qty"
                        (inputValueEmit)="requirementDetails.qty = $event">
                      </app-input>
                    </div>
                    <div class="d-none d-md-block col-auto px-0 d-flex align-items-center invisible me-3">
                      <div class="pt-1">
                        <app-svg iconType="CrossCircle"></app-svg>
                      </div>
                    </div>
                    <ng-container *ngFor="let item of additionalQuantities;let i = index">
                      <div class="col-10 col-md-5 col-lg-2 ps-0 mb-2 mb-lg-0" [ngClass]="{'mt-3': i >= 4}">
                        <app-input onlyNumbers [inputLabel]="'Quantity ' + (i+2)" [inputType]="'text'"
                          [inputValue]="item?.quantity" (inputValueEmit)="item.quantity = $event">
                        </app-input>
                      </div>
                      <div class="col-auto px-0 d-flex align-items-center" [ngClass]="{'me-3': i != 3,'mt-3': i >= 4}">
                        <div class="pt-1">
                          <span (click)="deleteQty(i)">
                            <app-svg iconType="CrossCircle"></app-svg>
                          </span>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </ng-template>
              </li>
              <!-- requirement Additional Quantity details end -->


            </ul>
            <div [ngbNavOutlet]="nav" class="ngb-nav"></div>
          </div>
        </div>
        <!-- requirement information end -->
        <!-- requirement opportunity start -->
        <div class="row mx-0 mt-3 mt-lg-0 OpportunityDetails px-0">
          <div class="col-12 px-lg-1 px-xl-1 pb-2 opportunity-section mb-3">
            <span class="secondary-text text-primary-color">Opportunity Details</span>
          </div>
          <ng-container *ngIf="opportunityDetails?.opportunityTypeId == 1;else opportunityTypeId2">
            <div class="row mx-0 px-0">
              <div class="col-12 col-md-6 col-lg-2 px-0 pe-md-2">
                <div>
                  <div class="col mb-1">
                    <span class="d-flex secondary-text text-nowrap text-light-gray">Opportunity Type:<i class="fst-normal ps-1 p-0 text-danger">*</i></span>
                  </div>
                  <div class="d-flex gap-3">
                    <div class="radio radio-p col-4 d-flex p-l-radio"
                      *ngFor="let saleItem of saleStageList; let i = index">
                      <input type="radio" name="radiogroup1" [value]="saleItem.id"
                        [disabled]="requirementInfo.isInHouseRequirement"
                        [checked]="opportunityDetails.opportunityTypeId === saleItem.id" [id]="saleItem.id"
                        (change)="onSelectionChange(saleItem)" />
                      <label class="secondary-text"  for="{{ saleItem.id }}">{{ saleItem.name }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-md-2 px-0 ps-md-2 pe-lg-2">
                <div class="mb-2">
                  <span class="font-16 text-light-gray">Type</span>
                </div>
                <div class="col-12 p-0" style="overflow:scroll;">
                  <div class="d-flex flex-wrap labl-div align-div typeScroll">
                    <app-button *ngFor="let items of getAllDropdown?.opportunityBuyTypeList; let i = index"
                      [buttonType]="'button'" [button_2]="true" (click)="selecteAccountTypesId(items, i)" [buttonClass]="
                 'button-lable-primary btn-hover font-14 mx-1 ps-2 m-b-5 text-center d-flex justify-content-center align-items-center'
               " [spanClass]="'text-truncate'" [buttonLable]="items.name" [ngClass]="items.id === (opportunityDetails.typeId?.[0]?.id || '') ? 'selected' : ''">
                    </app-button>
                  </div>
                </div>
              </div>
              <div class="mini-div-1 my-2 my-lg-0 col-12 col-md-6 col-lg-3 px-0 pe-md-2 ps-lg-2">
                <div class="row mx-0 pe-lg-1">
                  <div class="col-12 d-flex justify-content-between px-0">
                    <div class="d-flex">
                      <div class="text-light-gray secondary-text text-nowrap me-2">
                        Close Probability:
                      </div>
                      <div class="text-primary-color text-nowrap secondary-text">
                        {{
                        opportunityDetails?.closeProbability > 0
                        ? startRating +
                        " to " +
                        opportunityDetails?.closeProbability +
                        ""
                        : "0"
                        }}
                      </div>
                    </div>
                    <div class="nowrap add-req p-0 text-semi-primary">
                      <div class="hand d-flex" (click)="clearStatusBar()">
                        <!-- <app-svg-icon 
                     [src]="'../../../../../../../assets/SVGIcons/smallClaer.svg'"
                     class="d-flex align-items-center me-2 text-semi-primary"
                   >
                   </app-svg-icon> -->

                        <app-svg iconType="SmallClaer" class="d-flex align-items-center me-2 text-semi-primary">
                        </app-svg>

                        <span class="pe-0 font-14 text-semi-primary">
                          Clear
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-12 px-0">
                    <ngx-slider [(value)]="startRating" [(highValue)]="opportunityDetails.closeProbability"
                      [options]="options">
                    </ngx-slider>
                    <div class="row mx-0">
                      <div class="col-6 text-start p-0 me-1 text-light-gray">
                        <span class="secondary-text">0</span>
                      </div>
                      <div class="col d-flex justify-content-end p-0 text-light-gray">
                        <span class="secondary-text">100</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg mb-4 px-0 ps-md-2">
                <app-input [inputLabel]="'End Customer/Industry'" [inputType]="'text'"
                  [inputValue]="opportunityDetails?.endCustomer"
                  (inputValueEmit)="opportunityDetails.endCustomer = $event">
                </app-input>
              </div>
            </div>
            <div class="row mx-0 mt-1 px-0">
              <div class="col-12 col-md-6 col-lg-3 mb-3 mb-lg-0 px-0 pe-md-2">
                <app-input [inputLabel]="'Project Name'" [inputType]="'text'"
                  [inputValue]="opportunityDetails?.projectName"
                  (inputValueEmit)="opportunityDetails.projectName = $event">
                </app-input>
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-3 mb-lg-0 px-0 ps-md-2 pe-lg-2">
                <app-input [inputLabel]="'Application'" [inputType]="'text'"
                  [inputValue]="opportunityDetails?.application"
                  (inputValueEmit)="opportunityDetails.application = $event">
                </app-input>
              </div>
              <div class="col-12 col-md-6 col-lg mb-0 px-0 pe-md-2 ps-lg-2 pe-lg-0">
                <app-input [inputLabel]="'Opportunity Notes'" [inputType]="'text'"
                  [inputValue]="opportunityDetails?.opportunityNotes"
                  (inputValueEmit)="opportunityDetails.opportunityNotes = $event">
                </app-input>
              </div>
            </div>
          </ng-container>
          <ng-template #opportunityTypeId2>
            <div class="row mx-0 px-0">
              <div class="col-12 col-md-6 col-lg-3 col-xl-2 mb-2 px-0 pe-md-2">
                <div class="">
                  <div class="col mb-1">
                    <span class="d-flex secondary-text text-nowrap text-light-gray">Opportunity Type:<i class="fst-normal ps-1 p-0 text-danger">*</i></span>
                  </div>
                  <div class="d-flex">
                    <div class="radio radio-p col-4 d-flex p-l-radio"
                      *ngFor="let saleItem of saleStageList; let i = index">
                      <input type="radio" name="radiogroup1" [value]="saleItem.id"
                        [disabled]="requirementInfo.isInHouseRequirement"
                        [checked]="opportunityDetails?.opportunityTypeId === saleItem.id" [id]="saleItem.id"
                        (change)="onSelectionChange(saleItem)" />
                      <label class="secondary-text" for="{{ saleItem.id }}">{{ saleItem.name }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-3 col-xl-2 mb-2 px-0 ps-md-2 pe-lg-2">
                <app-date-picker [time]="false" [inputLabel]="'Est. Start Date'"
                  [inputValue]="opportunityDetails?.estStartDate"
                  (inputValueEmit)="opportunityDetails.estStartDate = $event"
                  [isDisabled]="requirementInfo.isInHouseRequirement"
                  [adjustPopupPosition]="'top-right'"
                  ></app-date-picker>

              </div>
              <div class="col-12 col-md-6 col-lg-3 col-xl-2 mb-2 px-0 pe-md-2 ps-lg-2">
                <app-date-picker [time]="false" [inputLabel]="'Bid Deadline'"
                  [inputValue]="opportunityDetails?.bidDeadline"
                  (inputValueEmit)="opportunityDetails.bidDeadline = $event"
                  [isDisabled]="requirementInfo.isInHouseRequirement"
                  [adjustPopupPosition]="'top-right'"
                  ></app-date-picker>
              </div>
              <div class="col-12 col-md-6 col-lg-3 col-xl-3 mb-2 px-0 ps-md-2 pe-xl-2">
                <app-input [inputLabel]="'End Customer/Industry'" [inputType]="'text'"
                  [inputValue]="opportunityDetails?.endCustomer"
                  (inputValueEmit)="opportunityDetails.endCustomer = $event"
                  [isInputDisabled]="requirementInfo.isInHouseRequirement">
                </app-input>
              </div>
              <div class="col-12 col-md-6 col-lg-3 col-xl-3 mb-2 px-0 pe-md-2 ps-lg-0 ps-xl-2 pe-xl-0">
                <app-input [inputLabel]="'Project Name'" [inputType]="'text'"
                  [inputValue]="opportunityDetails?.projectName"
                  (inputValueEmit)="opportunityDetails.projectName = $event"
                  [isInputDisabled]="requirementInfo.isInHouseRequirement">
                </app-input>
              </div>
            </div>
            <div class="row px-0 mx-0">
              <div class="col-12 col-md-6 col-lg-2 mb-3 mb-lg-0 px-0 pe-md-2">
                <div class="col mb-1">
                  <span class="d-flex text-nowrap text-light-gray secondary-text">Project Approved</span>
                </div>
                <div class="d-flex gap-3">
                  <div class="radio radio-p col-4 d-flex p-l-radio" *ngFor="let item of projectList; let i = index">
                    <input type="radio" name="radiogroup" [value]="item?.active"
                      [disabled]="requirementInfo.isInHouseRequirement"
                      [checked]="opportunityDetails?.isProjectApproved === item.active" [id]="item.active"
                      (change)="onSelectionProjectChange(item)" />
                    <label class="secondary-text" for="{{ item.active }}">{{ item.name }}</label>
                  </div>
                </div>
              </div>
              <div class="mini-div-1 col-12 col-md-6 col-lg-3 mb-3 mb-lg-0 px-0 ps-md-2 pe-lg-2">
                <div class="row mx-0 pe-lg-1">
                  <div class="col-12 d-flex justify-content-between px-0">
                    <div class="d-flex">
                      <div class="text-light-gray secondary-text text-nowrap me-2">
                        Close Probability:
                      </div>
                      <div class="text-primary-color text-nowrap secondary-text">
                        {{
                        opportunityDetails?.closeProbability > 0
                        ? startRating +
                        " to " +
                        opportunityDetails?.closeProbability +
                        ""
                        : "0"
                        }}
                      </div>
                    </div>
                    <div class="nowrap add-req p-0 text-semi-primary">
                      <div class="hand d-flex" (click)="clearStatusBar()">
                        <app-svg iconType="SmallClaer" class="d-flex align-items-center me-2 text-semi-primary">
                        </app-svg>
                        <span class="pe-0 font-14 text-semi-primary">Clear</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-12 px-0">
                    <ngx-slider [(value)]="startRating" [(highValue)]="highValue"
                      [options]="options">
                    </ngx-slider>
                    <div class="row mx-0">
                      <div class="col-6 text-start p-0 me-1 text-light-gray">
                        <span class="popup-secondary-text">0</span>
                      </div>
                      <div class="col d-flex justify-content-end p-0 text-light-gray">
                        <span class="popup-secondary-text">100</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-3 mb-3 mb-lg-0 px-0 pe-md-2 ps-lg-3">
                <app-input [inputLabel]="'Application'" [inputType]="'text'"
                  [inputValue]="opportunityDetails?.application"
                  (inputValueEmit)="opportunityDetails.application = $event"
                  [isInputDisabled]="requirementInfo.isInHouseRequirement">
                </app-input>
              </div>
              <div class="col-12 col-md-6 col-lg mb-0 px-0 ps-md-2">
                <app-input [inputLabel]="'Opportunity Notes'" [inputType]="'text'"
                  [inputValue]="opportunityDetails?.opportunityNotes"
                  (inputValueEmit)="opportunityDetails.opportunityNotes = $event"
                  [isInputDisabled]="requirementInfo.isInHouseRequirement">
                </app-input>
              </div>
            </div>
          </ng-template>
        </div>
        <!-- requirement opportunity end -->
  </div>

  <div class="modal-footer border-0">
    <div class="d-flex m-0 gap-3 justify-content-end flex-wrap">
      <app-button [buttonType]="'button'" [button_2]="true" [buttonClass]="'button button-danger popup-button'"
        (click)="activeModal.close()" [buttonLable]="enumButtonName.CANCEL">
      </app-button>
      <ng-container *ngIf="!data?.id">
        <app-button [buttonType]="'button'" [button_2]="true" [buttonClass]="getButtonClass('draft')"
          [buttonLable]="enumButtonName.SAVE_AS_DRAFT" (click)="handleAction('draft')">
        </app-button>
      </ng-container>
      <app-button [buttonType]="'submit'" [button_2]="true" [buttonClass]="getButtonClass('submit')"
        [buttonLable]=" CompnayID != undefined ? editName :  headingsNames"
        (click)="handleAction('submit')">
      </app-button>
    </div>
  </div>
</div>